"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _MenuContext = _interopRequireDefault(require("./MenuContext"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MenuCard = _interopRequireDefault(require("./MenuCard"));

var MenuBody = /*#__PURE__*/_react["default"].memo(function (_ref) {
  _ref = Object.assign({}, {
  wrapProps: {},
  CardComponent: _MenuCard["default"]
}, _ref);
  var CardComponent = _ref.CardComponent,
      wrapProps = _ref.wrapProps,
      card = _ref.card,
      cards = _ref.cards,
      rootHeader = _ref.rootHeader,
      rootFooter = _ref.rootFooter,
      children = _ref.children;

  var _useContext = (0, _react.useContext)(_MenuContext["default"]),
      classes = _useContext.classes,
      drawerWidth = _useContext.drawerWidth;

  var position = -drawerWidth * card;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: classes.bodyWrap,
    style: {
      transform: "translateX(".concat(position, "px)")
    }
  }, wrapProps), cards.map(function (item, depth) {
    return /*#__PURE__*/_react["default"].createElement(CardComponent, {
      card: card,
      key: depth,
      item: item,
      depth: depth,
      rootHeader: rootHeader,
      rootFooter: rootFooter
    });
  })));
});

MenuBody.propTypes = {
  /**
   * Additional props for the wrap element
   */
  wrapProps: _propTypes["default"].object,

  /**
   * Overrides the default component used to display menu cards
   */
  CardComponent: _propTypes["default"].elementType.isRequired
};
var _default = MenuBody;
exports["default"] = _default;
